import { render, staticRenderFns } from "./invited.vue?vue&type=template&id=57d5fb80&scoped=true"
import script from "./invited.vue?vue&type=script&lang=js"
export * from "./invited.vue?vue&type=script&lang=js"
import style0 from "./invited.vue?vue&type=style&index=0&id=57d5fb80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d5fb80",
  null
  
)

export default component.exports